var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnowflake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#snowflake_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.793.96a1 1 0 0 1 1.414 0L10 2.752 11.793.96a1 1 0 1 1 1.414 1.414L11 4.58v3.687l3.193-1.844.808-3.015a1 1 0 1 1 1.932.518l-.656 2.45 2.449.655a1 1 0 1 1-.518 1.932l-3.015-.808L12 10l3.193 1.843 3.015-.807a1 1 0 0 1 .518 1.931l-2.45.657.657 2.449A1 1 0 1 1 15 16.59l-.808-3.015L11 11.732v3.687l2.207 2.207a1 1 0 1 1-1.414 1.414L10 17.247 8.207 19.04a1 1 0 0 1-1.414-1.414L9 15.42v-3.687l-3.193 1.844-.808 3.014a1 1 0 1 1-1.932-.517l.656-2.45-2.449-.655a1 1 0 0 1 .518-1.932l3.015.808L8 10 4.807 8.156l-3.015.808a1 1 0 1 1-.518-1.931l2.45-.657-.657-2.449A1 1 0 1 1 5 3.41l.808 3.014L9 8.268V4.58L6.793 2.374a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "snowflake_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgSnowflake.displayName = "SvgSnowflake";
export { SvgSnowflake as ReactComponent };
export default SvgSnowflake;